import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { imgUrl } from "../admin/adminApi";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true); setNotFound(false);
    axios.get(`${API}/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setNotFound(true)).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
        {loading ? (
          <div className="py-20 text-center"><Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" /></div>
        ) : notFound ? (
          <div className="py-20 text-center text-gray-500">Page not found.</div>
        ) : (
          <article>
            <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900">{page.title}</h1>
            <div className="w-20 h-1 bg-accent rounded-full mt-4" />
            {page.image ? <img src={imgUrl(page.image)} alt={page.title} className="w-full rounded-2xl mt-6 object-cover max-h-72" /> : null}
            <div className="mt-6 text-gray-700 leading-relaxed whitespace-pre-line">{page.content}</div>
          </article>
        )}
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
};

export default PageView;
